/* eslint-disable no-undef */
import {
  LOG_TRANSACTION_ALL,
  LOG_TRANSACTION_GET,
  LOG_TRANSACTION_DEL,
  LOG_TRANSACTION_PUT,
  LOG_TRANSACTION_POST,
  LOG_TRANSACTION_LOADING,
  LOG_TRANSACTION_ERROR,
  LOG_TRANSACTION_RESET,
} from '../types';

import api from '../../../utils/functions/api';

export const logTransactionCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: LOG_TRANSACTION_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/gold`,
      payload,
    );
    dispatch({ type: LOG_TRANSACTION_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LOG_TRANSACTION_ERROR });
    throw new Error(error);
  }
};

export const logTransactionAll = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      date = '',
      place = '',
      month = '',
      startDate = '',
      endDate = ' ',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/logTransaction?name=${name}&size=${size}&page=${page}&date=${date}&place=${place}&month=${month}&startDate=${startDate}&endDate=${endDate}`,
    );
    if (status === 200) {
      dispatch({ type: LOG_TRANSACTION_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: LOG_TRANSACTION_ERROR });
    throw new Error(error);
  }
};

export const logTransactionGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/logTransaction/${id}`,
    );
    if (status === 200) {
      dispatch({ type: LOG_TRANSACTION_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: LOG_TRANSACTION_ERROR });
    throw new Error(error);
  }
};

export const logTransactionPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: LOG_TRANSACTION_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/logTransaction/${id}`,
      payload,
    );
    dispatch({ type: LOG_TRANSACTION_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LOG_TRANSACTION_ERROR });
    throw new Error(error);
  }
};
export const logTransactionDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: LOG_TRANSACTION_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/logTransaction/${id}`,
    );
    dispatch({ type: LOG_TRANSACTION_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LOG_TRANSACTION_ERROR });
    console.error(error);
    throw new Error(error);
  }
};

export const logTransactionReset = () => async (dispatch) => {
  try {
    dispatch({ type: LOG_TRANSACTION_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: LOG_TRANSACTION_ERROR });
    throw new Error(error);
  }
};
